export default "__VITE_ASSET__4d388888__"